import React from 'react'
import { UNDER_CONSTRUCTION } from '../../global/assets/Icons'

function UnderConstruction() {
  return (
    <div style={{ display:'flex', 
    position:'relative',
    justifyContent :'center', 
    alignItems:'center'}}>
    
       <div style={{ position:'absolute', 
       fontFamily:'Inter Medium', 
       fontSize:'50px',
       top :50,
       color:'#181436'}}>Page Under Construction</div>
       <img style={{marginTop :'100px', marginBottom:'100px'}} width='500px'  src={UNDER_CONSTRUCTION} alt="" ></img>

    </div>
  )
}

export default UnderConstruction